<template>
  <div>
    <h2 class="auth-heading">Two Factor Authentication</h2>

    <v-card-text>


      <div v-if="useRecovery" style="text-align: center;">
        <h4>Enter one of your recovery codes below</h4>
        <v-text-field
          id="code2"
          outlined
          type="text"
          placeholder="XXXXXXXX-XXXXXXXX"
          v-model="recoveryCode"
          class="code-input longer"
        ></v-text-field>

        <div><a style="cursor: pointer;" @click="changeRecovery">Use code from two factor app</a></div>
      </div>

      <div v-else style="text-align: center;">
        <div class="input-number-clear">
          <h4>Enter the 6 digit code returned from your two factor app below</h4>
          <v-text-field
            id="code1"
            outlined
            min="0"
            maxLength="6"
            type="number"
            v-model="code"
            class="code-input"
          ></v-text-field>
        </div>

        <div><a style="cursor: pointer;" @click="changeRecovery">Or use recovery code</a></div>
      </div>


    </v-card-text>
    <v-card-actions>

      <v-btn class="center-button" color="primary" type="submit" @click="verify2FA">Verify Code</v-btn>

    </v-card-actions>
  </div>
</template>

<script>
import {recaptcha} from "@/mixins/captcha";

export default {
  name: "TwoFactorVerify",
  mixins: [recaptcha],
  data: () => ({
    code: null,
    useRecovery: false,
    recoveryCode: null
  }),
  methods: {
    viewLogin() {
      this.$emit('changeState', "initial");
    },
    changeRecovery() {
      this.code = null;
      this.recoveryCode = null;

      this.useRecovery = !this.useRecovery;
    },
    async verify2FA() {
      if (!this.useRecovery && (!this.code || this.code.length !== 6)) {
        const detail = "Please enter a valid 6 digit code from your Two Factor App";
        await this.$store.dispatch("notification/triggerError", { detail: detail });
        return;
      }

      if (this.useRecovery && !this.recoveryCode) {
        const detail = "Please enter a recovery code";
        await this.$store.dispatch("notification/triggerError", { detail: detail });
        return;
      }

      await this.$store.dispatch("loader/loaderInitiate", { title: "Verifying Two Factor Authentication" });

      const captcha = await this.recaptchaToken();
      const result = await this.$store.dispatch("auth/twoFactorVerify", { code: this.code, recoveryCode: this.recoveryCode, captcha: captcha });

      await this.$store.dispatch("loader/loaderCancel");

      if (result) {
        if (result.state === 'redirect_third_party') {
          this.$emit('utilityClick', result.third_party.account, result.third_party.otp);
          return;
        }

        this.$emit('loginSuccess');
      } else {
        this.viewLogin();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.code-input {
  font-size: 1.5rem;
  width: 150px;
  text-align: center;
  margin: 10px auto;

  &.longer {
    width: 400px;
  }
}

#code1, #code2 {
  text-align: center;
}

.v-input input {
  text-align: center;
}

.auth-heading {
  text-transform: none !important;
  background-color: #5d3791;
  color: white !important;
  padding: 15px 10px;
}
</style>
